var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 19,
    viewBox: "0 0 35 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.826 15.6754H8.02893L8.28321 1L24.9565 1.18163V15.6754H19.0355",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9911 4.81409L30.9484 5.06836C31.2754 5.06836 32.0164 5.2282 32.3651 5.86752C32.7139 6.50685 33.576 8.48295 33.9634 9.39108V15.3848H31.566",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6622 9.39136H33.9999",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.6156H6.39326",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77881 7.2478H6.3558",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66821 10.9535H6.28364",
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.7486,
    cy: 16.0747,
    r: 2.1197,
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.7714,
    cy: 16.0747,
    r: 2.1197,
    stroke: "#B2CAE7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckicon);
export default __webpack_public_path__ + "static/media/truckicon.03d959089465c3ecdf5086485816d402.svg";
export { ForwardRef as ReactComponent };